import eachElement from 'Utils/eachElement.js';

document.addEventListener('DOMContentLoaded', () => {
	const lifecycleSection = document.querySelector('.lifecycle-hover-container');
	const lifecycleImage = lifecycleSection?.querySelector('.lifecycle-image');
	const mobileBreakpointQuery = window.matchMedia('(max-width: 1023px)');
	const isMobileWidth = () => mobileBreakpointQuery.matches;

	if (!lifecycleImage) {
		return;
	}

	/* Remove the highlight class from every lifecycle segment. */
	const clearAllSegments = () => {
		for (const section of lifecycleImage.querySelectorAll('.lifecycle')) {
			section.classList.remove('is-active');
		}
	};

	/* Highlight the requested segments after clearing any previous selection. */
	const highlightSegments = (segments = []) => {
		clearAllSegments();
		for (const segment of segments) {
			for (const element of lifecycleImage.querySelectorAll(`.lifecycle-${segment}`)) {
				element.classList.add('is-active');
			}
		}
	};

	/* Read the comma-separated segments stored on each trigger button or practice. */
	const getSegmentsFrom = element => element.dataset.segments?.split(',') || [];

	/* Desktop hover interactions only highlight while the pointer is over the link. */
	eachElement('.lifecycle-hover-container .button[data-segments]', link => {
		const segments = getSegmentsFrom(link);
		link.addEventListener('mouseenter', () => {
			requestAnimationFrame(() => {
				highlightSegments(segments);
			});
		});

		link.addEventListener('mouseleave', clearAllSegments);
	});

	let selectedPractice = null;

	/* Reset everything that was highlighted via the mobile practice controls. */
	const clearHighlights = () => {
		clearAllSegments();
		selectedPractice?.classList.remove('is-selected');
		selectedPractice = null;
	};

	/* Mobile behavior: tap to toggle a practice and highlight segments. */
	eachElement('.lifecycle-practice', practice => {
		practice.addEventListener('click', event => {
			if (!isMobileWidth()) {
				return;
			}

			const segments = getSegmentsFrom(practice);

			if (selectedPractice === practice) {
				return;
			}

			event.preventDefault();
			selectedPractice?.classList.remove('is-selected');
			selectedPractice = practice;
			practice.classList.add('is-selected');
			highlightSegments(segments);
		});
	});

	document.addEventListener('click', event => {
		if (!event.target.closest('.lifecycle-practice')) {
			clearHighlights();
		}
	});
});
